import * as Config from '../config';
import { useContext } from "react";
import { ReactReduxContext } from 'react-redux';
// import { useHistory } from "react-router-dom";

import useGetFromApi from './useGetFromApi';
import { setSelectedItems, addDragItems } from "../actions/index";

const useCharts = (id, pathApi, perPage = 100, type = 'CHART', customReduceFormat = null) => {
  const [response] = useGetFromApi(id, pathApi, perPage, customReduceFormat);
  const { store } = useContext(ReactReduxContext);
  const { dispatch } = store;
  const state = store.getState();
  let result = (response) ? { ...response } : null;
  // let globalHistory = useHistory();

  const dragMore = (items, next) => {
    const req = (next.includes(`https`)) ? state.api.getFromURL(next) : state.api.getFromApi(next, false);
    req.then( response => {
      const newItems = [...items, ...response.data.results.map(Config.formattedFromBP)];
      if (response.data.next) {
        dragMore(newItems, response.data.next);
      } else {
        dispatch(setSelectedItems(newItems));
        dispatch(addDragItems());
      }
    } ).catch( e => console.log(`error`, e) );
  }

  const beginDrag = (id) => {
    return () => {
      dragMore([], `/v4/catalog/charts/${id}/tracks/?per_page=100`);
    }
  }

  const resizeImg = (url) => url.replace(`500x500`, `200x200`).replace(`1400x1400`, `200x200`);

  const format = x => ({
    id: x.id,
    title: (type === 'CHART') ? x.name || `UNKNOW` : null,
    category: (x.category) ? x.category : null,
    publishDate: (x.publish_date) ? x.publish_date : (x.add_date ? x.add_date : null),
    changeDate: (x.change_date) ? x.change_date : (x.updated_date ? x.updated_date : null),
    isUpdated: (x.isUpdated) ? x.isUpdated : false,
    updatedCallback: () => {
      let storeDD = JSON.parse(localStorage.getItem('dd'));
      const item = (storeDD) ? storeDD.find( y => y.n === x.category ) : null;
      if (item) {
        item.u = x.change_date
      } else {
        if (!storeDD) { storeDD = [] }
        storeDD.push({n: x.category, u: x.change_date});
      }
      localStorage.setItem('dd', JSON.stringify(storeDD))
    },
    artists: (x.person && type === 'CHART') ? [{
      id: x.person.id,
      name: x.person.owner_name,
      slug: x.person.owner_slug
    }] : [],
    artists_s: (x.person) ? x.person.owner_name : `DJ UNKNOW`,
    img: (x.image && x.image.uri !== Config.DEFAULT_IMG) ? resizeImg(x.image.uri) : ( (x.person && x.person.owner_image) ? resizeImg(x.person.owner_image) : Config.DEFAULT_IMG),
    images: [(x.image && x.image.uri !== Config.DEFAULT_IMG) ? resizeImg(x.image.uri) : ( (x.person && x.person.owner_image) ? resizeImg(x.person.owner_image) : Config.DEFAULT_IMG)],
    audio: { //USED BY THE SOURCE D&D
      id: x.id,
      name: x.name,
      tracks: x.tracks,
      uri: `/charts/${x.id}`,
      parentPathApi: pathApi,
      artists_s: (x.person) ? x.person.owner_name : `DJ UNKNOW`,
      extra: {
        covers: [(x.image && x.image.uri !== Config.DEFAULT_IMG) ? resizeImg(x.image.uri) : ( (x.person && x.person.owner_image) ? resizeImg(x.person.owner_image) : Config.DEFAULT_IMG)],
        fromDJ: (x.person) ? x.person.owner_name : null,
        fromDJID: (x.person) ? x.person.id : null
      }
    },
    tracks: x.track_count,
    type,
    dragEnabled: true,
    playEnabled: false,
    beginDrag: beginDrag(x.id),
    isActive: null // (globalHistory.location.pathname === `/charts/${x.id}`) - DEAD CODE
  });

  if (response) {
    result.items = (response.items) ? response.items.map(format) : null;
  } 

  return [result];
};

export default useCharts;
